import axios from "axios";
import { LoggingConstants } from "Constants";
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TIdAndName, TSearchUnitDTO } from "Types";

export class SearchUnitController {
    public async searchAsync(query: string): Promise<TSearchUnitDTO[]> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SearchUnitSearch`, {
            query: query
        });
        
        const result = await axios.get<TSearchUnitDTO[]>(`${AxiosHelperSingleton.getServerBaseURL()}api/searchunits/search?query=${query}`);
        return result.data;
    }

    public searchUnitToIdAndName(result: TSearchUnitDTO): TIdAndName {
        return {id: result.id, name: result.name};
    }
}

export const SearchUnitControllerSingleton = new SearchUnitController(); 